<template>
  <b-row>
    <b-col>
      <b-card>
        <b-row>
          <b-col cols="12">
            <b-button variant="primary" @click="$router.push({ name: 'form-new' })">
              <feather-icon icon="PlusIcon" />
              Novo formulário
            </b-button>
          </b-col>
        </b-row>
      </b-card>

      <b-card>
        <b-table responsive="sm"
                 :fields="table.fields"
                 show-empty
                 :items="forms">
          <template #empty>
            <div class="text-center">
              Não há formulários cadastrados.
            </div>
          </template>
          <template #cell(actions)="data">
            <div>
              <!-- edição -->
              <b-button size="sm"
                        class="ml-1"
                        variant="primary"
                        @click="$router.push({ name: 'form-edit', params: { id: data.item._id } })">
                <feather-icon
                  class="cursor-pointer"
                  icon="Edit2Icon" />
              </b-button>

              <!-- exclusao -->
              <b-button size="sm"
                        class="ml-1"
                        variant="danger"
                        @click="deleteCustomer(data.item)">
                <feather-icon
                  class="cursor-pointer"
                  icon="TrashIcon" />
              </b-button>
            </div>
          </template>
        </b-table>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {mapGetters} from "vuex"

export default {
  name: 'FormList',
  computed: {
    ...mapGetters({
      forms: 'forms/forms'
    })
  },
  data () {
    return {
      table: {
        fields: [
          {
            key: 'title',
            label: 'Título'
          },
          {
            key: 'description',
            label: 'Descrição'
          },
          {
            key: 'actions',
            label: 'Ações'
          }
        ]
      },
    }
  },
  mounted () {
    this.$store.dispatch('forms/getForms', {})
  },
  methods: {
    deleteCustomer (id) {
      console.log(id)
    }
  }
}
</script>
